import { useState } from "react";
import { EXPLAINERS } from "../lib/explainers";

/**
 * Sits above each analysis. Collapsed it shows the question the analysis
 * answers; expanded it explains why the obvious metric fails, and what the
 * shapes in the table mean.
 *
 * Open by default the first time, because a ranked table nobody understands
 * is worse than no table.
 */
export function Explainer({ metricId }: { metricId: string }) {
  const e = EXPLAINERS[metricId];
  const [open, setOpen] = useState(true);
  if (!e) return null;

  return (
    <div className={`xp ${open ? "open" : ""}`}>
      <button className="xp-head" onClick={() => setOpen(!open)} aria-expanded={open}>
        <span className={`xp-caret ${open ? "on" : ""}`} aria-hidden="true" />
        <span className="xp-question">{e.question}</span>
        <span className="xp-toggle">{open ? "Hide" : "Explain"}</span>
      </button>

      {open && (
        <div className="xp-body">
          <div className="xp-cols">
            <div>
              <div className="xp-label">What most people do</div>
              <p className="xp-naive">{e.naive}</p>
              <div className="xp-label">Why that misleads</div>
              <p>{e.problem}</p>
            </div>
            <div className="xp-visual">{e.visual}</div>
          </div>

          <div className="xp-example">
            <div className="xp-label">Worked example</div>
            <p>{e.example}</p>
          </div>

          <div className="xp-label">What to look for</div>
          <table className="xp-patterns">
            <thead>
              <tr><th>If you see</th><th>It means</th><th>Do this</th></tr>
            </thead>
            <tbody>
              {e.patterns.map((p, i) => (
                <tr key={i}>
                  <td><strong>{p.signal}</strong></td>
                  <td>{p.means}</td>
                  <td>{p.action}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
